import Icon from '@ant-design/icons'
import * as React from 'react'

import { NovaIconProps } from '../types/iconTypes'

const ArrowRight = (props: NovaIconProps) => (
  <Icon
    {...props}
    component={() => (
      <svg
        width="1em"
        height="1em"
        focusable={false}
        viewBox="2 2 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M27.7025 15.2889C27.7191 15.3052 27.735 15.3221 27.7504 15.3395C27.8173 15.4153 27.8708 15.4989 27.9108 15.587C27.9681 15.713 28 15.8531 28 16.0005C28 16.148 27.9681 16.288 27.9108 16.4141C27.8708 16.5022 27.8173 16.5857 27.7504 16.6615C27.735 16.679 27.7191 16.6959 27.7025 16.7122L17.8076 26.6071C17.4171 26.9977 16.7839 26.9977 16.3934 26.6071C16.0028 26.2166 16.0028 25.5834 16.3934 25.1929L24.5858 17.0005L6 17.0005C5.44772 17.0005 5 16.5528 5 16.0005C5 15.4482 5.44772 15.0005 6 15.0005L24.5858 15.0005L16.3934 6.80814C16.0028 6.41762 16.0028 5.78445 16.3934 5.39393C16.7839 5.0034 17.4171 5.0034 17.8076 5.39393L27.7025 15.2889Z"
          fill="currentColor"
        />
      </svg>
    )}
  />
)

export default ArrowRight
